import { Button, Badge } from '@chakra-ui/react';
import { UilAngleDown } from '@iconscout/react-unicons';

const CreateEditProjectCanvasTrigger = ({
	onClickHandler,
	isOpen,
	onOpenRef,
	onCloseRef,
	getBadgeColor,
	projectInfo,
}) => {
	return (
		<Button
			onClick={(e) => onClickHandler({ isOpen, onOpenRef, onCloseRef })}
			ml={4}
			my={0}
			padding={0}
			variant={'invisible'}
			rightIcon={<UilAngleDown size={24} />}
		>
			<Badge
				lineHeight={'18px'}
				py={1 / 2}
				alignSelf="center"
				borderRadius="4px"
				px="2"
				colorScheme={getBadgeColor(projectInfo.type)}
			>
				{projectInfo.type ? projectInfo.type : 'projeto'}
			</Badge>
		</Button>
	);
};

export default CreateEditProjectCanvasTrigger;
